import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import Button from "../../components/Button/Button";
import DataTable from "../../components/Datatable/DataTable";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Skeleton from "react-loading-skeleton";
import UpdownArrow from "../../assets/images/updown-arrow.png";

class ShipmentsListing extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showCard: false,
		};
	}
	
	// componentDidMount() {}

  	// shouldComponentUpdate(nextProps, nextState) {
    // 	return true;
  	// }
	
	toggleCard = () => {
		this.setState({
			showCard: !this.state.showCard,
		});
	};
	
	render() {
		const { t } = this.props;
		
		return (
			<Auxiliary>
				<div className="row row-sm">
					<div className="breadcrumb-header justify-content-between">
						<div className="my-auto">
							<div className="d-flex">
								<h4 className="content-title mb-0 my-auto text-muted mt-1 tx-13 ml-2 mb-0">
									{t("price-list.shipments_pricelist")}
								</h4>
							</div>
						</div>
					</div>
					<div className="col-xl-12">
						<div className="card card-body card-primary">
							<div>
								{this.props.loading ? (
									<Skeleton count={2} />
								) : (
									<div className={`form-horizontal filter-function row ${this.state.showCard ? "open" : "close"} filter-wrapper-1`}>
										<div className="col-md-3 col-6">
											<div className="form-group">
												<label className="font-weight-bolder">
													{t("price-list.shipment_type")}
												</label>
												<div className="select-input">
													<select
														className="form-control filter-input"
														id="shipment_type"
														name="shipment_type"
														onChange={this.props.onInputChange}
														value={this.props.filter.shipment_type}
                          							>
														<option value=""></option>
														{this.props.ddTransportType && this.props.ddTransportType.map((val, idx) => {
															return (
																<option key={idx} value={val.id}>
																	{t(`price-list.${val.type}`)}
																</option>
															);
														})}
													</select>
													<img
														className="updown-icon"
														src={UpdownArrow}
														alt="Up Down Arrow"
													/>
												</div>
											</div>
										</div>
										
										<div className="col-md-3 col-6">
											<div className="form-group">
												<label className="font-weight-bolder">
													{t("price-list.courier_name")}
												</label>
                        						<div className="select-input">
													<select
														className="form-control filter-input"
														id="courier_name"
														name="courier_name"
														onChange={this.props.onInputChange}
														value={this.props.filter.courier_name}
													>
                            							<option value=""></option>
														{this.props.ddCourierName && this.props.ddCourierName.map((val, idx) => {
															const translatedCourier = t(`price-list.${val.courier_name}`);
															return (
																<option key={idx} value={val.id}>
																	{translatedCourier}
																</option>
															);
														})}
													</select>
													<img
														className="updown-icon"
														src={UpdownArrow}
														alt="Up Down Arrow"
													/>
												</div>
											</div>
										</div>

                    					<div className="col-md-3 col-6">
                      						<div className="form-group">
												<label className="font-weight-bolder">
													{t("price-list.warehouse")}
												</label>
												<div className="select-input">
													<select
														className="form-control filter-input"
														id="warehouse"
														name="warehouse"
														onChange={this.props.onInputChange}
														value={this.props.filter.warehouse}
													>
                            							<option value=""></option>
                            							{this.props.ddWarehouse && this.props.ddWarehouse.map((val, idx) => {
															const translatedWarehouse = t(`price-list.${val.warehouse}`);
															return (
																<option key={idx} value={val.id}>
																	{translatedWarehouse}
																</option>
															);
														})}
													</select>
													<img
														className="updown-icon"
														src={UpdownArrow}
														alt="Up Down Arrow"
													/>
												</div>
											</div>
										</div>

                    					<div className="col-md-3 col-6">
                      						<div className="form-group">
												<label className="font-weight-bolder">
													{t("price-list.state")}
												</label>
												<div className="select-input">
													<select
														className="form-control filter-input"
														id="state"
														name="state"
														onChange={this.props.onInputChange}
														value={this.props.filter.state}
													>
														<option value=""></option>
														{this.props.ddState && this.props.ddState.map((val, idx) => {
															const translatedDestination = t(`price-list.${val.state}`);
															return (
																<option key={idx} value={val.id}>
																	{translatedDestination}
																</option>
															);
														})}
													</select>
													<img
														className="updown-icon"
														src={UpdownArrow}
														alt="Up Down Arrow"
													/>
												</div>
											</div>
										</div>

										<div className="col-md-3 col-6">
                      						<div className="form-group">
												<label className="font-weight-bolder">
													{t("price-list.area")}
												</label>
												<div className="select-input">
													<select
														className="form-control filter-input"
														id="area"
														name="area"
														onChange={this.props.onInputChange}
														value={this.props.filter.area}
													>
														<option value=""></option>
														{this.props.ddArea && this.props.ddArea.map((val, idx) => {
															const translatedDestination = t(`price-list.${val.slug}`);
															return (
																<option key={idx} value={val.id}>
																	{translatedDestination}
																</option>
															);
														})}
													</select>
													<img
														className="updown-icon"
														src={UpdownArrow}
														alt="Up Down Arrow"
													/>
												</div>
											</div>
										</div>

                    					<div className="col-md-3 col-6">
                      						<div className="form-group">
												<label className="font-weight-bolder">
													{t("price-list.parcel_type")}
												</label>
												<div className="select-input">
													<select
														className="form-control filter-input"
														id="parcel_type"
														name="parcel_type"
														onChange={this.props.onInputChange}
														value={this.props.filter.parcel_type}
													>
														<option value=""></option>
														{this.props.ddParcelType && this.props.ddParcelType.map((val, idx) => {
															const translatedParcel = t(`price-list.${val.title}`);
															return (
																<option key={idx} value={val.id}>
																	{translatedParcel}
																</option>
															);
														})}
													</select>
													<img
														className="updown-icon"
														src={UpdownArrow}
														alt="Up Down Arrow"
													/>
												</div>
											</div>
										</div>
                    					<div className="col mt-auto">
                      						<div className="d">
												<Button
													typeButton="button"
													classValue="btn btn-blue"
													idValue="filter"
													buttonName={t("global.filter")}
													clicked={() => this.props.refreshHandler()}
												/>
                        						&nbsp;
												<Button
													typeButton="button"
													classValue="btn btn-secondary"
													idValue="reset"
													buttonName={t("global.reset")}
													clicked={() => this.props.clearHandler()}
												/>
											</div>
										</div>
									</div>
								)}
              				</div>
              				<div className="show-btn" onClick={() => this.toggleCard()}>
                				{this.state.showCard ? <AiFillMinusCircle /> : ( <AiFillPlusCircle />)}
							</div>
						</div>
					</div>

					<div className="col-xl-12">
						<div className="card">
							<div className="d-flex align-items-end">
								<div className="card-header pb-0 ps-0">
									<div className="d-flex justify-content-between">
										<h4 className="card-title mg-b-0">
											{t("price-list.shipment_price_listing")}
										</h4>
									</div>
								</div>

							<div className="d-flex">
									<div>
										<div className="btn-group">
											{this.props.permission.includes("shipment_store") && (
												<>
													<AiFillPlusCircle />
													<Button
														typeButton="button"
														classValue="btn btn-underline"
														idValue="btnCreateShipment"
														buttonName={t("price-list.add-shipment-price-setting")}
														clicked={() => this.props.changePageHandler("create")}
													/>
												</>
											)}
										</div>
									</div>
								</div>
							</div>

							<div className="card-body">
								<div className="table-responsive table-hover datatable">
									<DataTable
										keyField="shipmentId"
										data={this.props.dataListing}
										columns={this.props.columns}
										activePage={this.props.activePage}
										limit={this.props.limit}
										totalItems={this.props.totalRecords}
										paginationHandler={(val) =>
											this.props.datatablesChangeHandler(val, "activePage")
										}
										sizePerPageHandler={(val) =>
											this.props.datatablesChangeHandler(val, "limit")
										}
										classValue="dataTable table-bordered text-justify text-center"
										loading={this.props.loading}
										hideSearchBar={true}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Auxiliary>
		);
  	}
}

export default withNamespaces("translation")(ShipmentsListing);
